import html2canvas from 'html2canvas';
import imagesLoaded from 'imagesloaded';
import { Toast } from '@ymba/ym-ui';

let toast;
export function htmlToCanvas(element, opts) {
  const options = Object.assign({}, opts, {
    useCORS: true,
  });
  return new Promise(async (resolve, reject) => {
    toast = Toast.loading();
    const imgLoad = imagesLoaded(element, { background: true });
    imgLoad.on('done', async () => {
      const canvas = await html2canvas(element, options);
      return resolve(canvas);
    });
    imgLoad.on('fail', () => {
      toast.clear();
      return reject(new Error('img load fail'));
    });
  });
}


export function canvasToImage(canvas) {
  const img = new Image();
  img.crossOrigin = 'Anonymous';
  img.className = 'result-img';
  img.src = canvas.toDataURL('image/png');
  toast.clear();
  return img;
}
